import { useApprovalInbox } from "./useApprovalInbox";

export const usePendingApprovalCount = (
  bookkeepingYearId: string | undefined
) => {
  const { data, isLoading } = useApprovalInbox(bookkeepingYearId);
  // Inbox is already filtered to pending/changesRequested in useApprovalInbox.
  return { count: data?.length ?? 0, isLoading };
};
